import Spinner from 'applications/web/pages/UserSignup/Shared/Spinner';
import LightBulb from 'assets/svg/icons/LightBulb';
import cn from 'classnames';
import type { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import { useGetGratificationById } from './hooks';
import { sharedMarkdownComponents } from './utils';

type AIChatMessageGratificationProps = {
  gratificationId: string;
  role?: string;
  className?: string;
};

const AIChatMessageGratification: FC<AIChatMessageGratificationProps> = ({
  gratificationId,
  className,
}) => {
  const { data: gratification, isLoading } =
    useGetGratificationById(gratificationId);

  return (
    <div
      className={cn(
        'text-primary-400 flex py-2 px-4 border border-primary-100 w-full text-left rounded-lg justify-between items-center',
        className,
      )}
    >
      <div className="flex items-center gap-2">
        <div className="p-2 rounded-full bg-taxes-200 flex items-center justify-center">
          <LightBulb className="w-4 h-4 text-taxes" />
        </div>
        <div>
          <h3 className="font-semibold text-primary-800">
            {gratification?.title}
          </h3>
          {gratification?.description && (
            <p className="text-sm">
              <ReactMarkdown components={sharedMarkdownComponents}>
                {gratification.description}
              </ReactMarkdown>
            </p>
          )}
        </div>
      </div>

      {isLoading ? <Spinner /> : null}
    </div>
  );
};

export default AIChatMessageGratification;
